import { createFileRoute } from '@tanstack/react-router'
import { requirePermission } from '../../../app/guards'
import { NewJournalPage } from '../../../features/accounting/journal-new-page'
import { accountsQueryOptions } from '../../../features/accounting/queries'

export const Route = createFileRoute('/_app/journal-entries/new')({
  staticData: { crumb: 'journalNew' },
  beforeLoad: ({ context }) => requirePermission(context.session, 'journals.post'),
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(accountsQueryOptions)
  },
  component: NewJournalPage,
})
